import { useMemo, useSyncExternalStore } from "react";

import type { IFirstTouch } from "~/feature/attribution/type";
import {
  readFirstTouchCookie,
  subscribeToFirstTouch,
} from "~/feature/attribution/utils/firstTouchCookie";
import { parseFirstTouch } from "~/feature/attribution/utils/parseFirstTouch";

const getServerSnapshot = (): string | null => null;

export const useFirstTouch = (): IFirstTouch | null => {
  const raw = useSyncExternalStore(
    subscribeToFirstTouch,
    readFirstTouchCookie,
    getServerSnapshot
  );

  return useMemo(() => parseFirstTouch(raw), [raw]);
};
